import zipcode_to_timezone from 'zipcode-to-timezone';

export const DEFAULT_BUSINESS_TZ = 'America/New_York';

// Every resource schedule boundary is written at midnight in this zone, so readers have to resolve
// the same one — core's overlaps() drops a match outright rather than degrading it. Falls back on
// an unknown zip too: lookup() returns null for zips it does not carry, and that yields NaN offsets
// downstream in asDateInTZ.
export const businessTimezone = (businessZip) =>
    (businessZip ? zipcode_to_timezone.lookup(businessZip) : null) || DEFAULT_BUSINESS_TZ;
